/**
 * 채권 상태 관련 유틸리티를 위한 컴포저블
 */
export function useBondStatus() {
  // 채권 발행 상태 매핑
  const statusTextMap = {
    OK :"검토완료",
    CREATED :"검토필요",
  };

  /**
   * 상태 코드를 한글 텍스트로 변환
   * @param {string} status - 상태 코드
   * @returns {string} 한글 상태 텍스트
   */
  const getStatusText = (status) => {
    return statusTextMap[status] || status;
  };

  /**
   * 상태에 따른 배지 CSS 클래스 반환
   * @param {string} status - 상태 코드
   * @returns {string} CSS 클래스 문자열
   */
  const getStatusBadgeClass = (status) => {
    const baseClass = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';

    const statusClassMap = {
      OK: 'bg-green-100 text-green-800',
      APPROVED: 'bg-green-100 text-green-800',
      ISSUANCE_UPDATED: 'bg-yellow-100 text-yellow-800',
      PENDING: 'bg-yellow-100 text-yellow-800',
      CREATED: 'bg-blue-100 text-blue-800',
      DRAFT: 'bg-blue-100 text-blue-800',
      REJECTED: 'bg-red-100 text-red-800',
    };

    const statusClass = statusClassMap[status] || 'bg-gray-100 text-gray-800';
    return `${baseClass} ${statusClass}`;
  };

  /**
   * 상태의 중요도 레벨 반환 (정렬 등에 사용)
   * @param {string} status - 상태 코드
   * @returns {number} 중요도 레벨 (낮을수록 높은 우선순위)
   */
  const getStatusPriority = (status) => {
    const priorityMap = {
      REJECTED: 1,
      ISSUANCE_UPDATED: 2,
      PENDING: 3,
      CREATED: 4,
      DRAFT: 5,
      OK: 6,
      APPROVED: 7,
    };

    return priorityMap[status] || 999;
  };

  /**
   * 상태가 완료 상태인지 확인
   * @param {string} status - 상태 코드
   * @returns {boolean} 완료 상태 여부
   */
  const isCompletedStatus = (status) => {
    return ['OK', 'APPROVED'].includes(status);
  };

  /**
   * 상태가 진행중 상태인지 확인
   * @param {string} status - 상태 코드
   * @returns {boolean} 진행중 상태 여부
   */
  const isPendingStatus = (status) => {
    return ['PENDING', 'CREATED', 'DRAFT', 'ISSUANCE_UPDATED'].includes(status);
  };

  /**
   * 상태가 오류/거부 상태인지 확인
   * @param {string} status - 상태 코드
   * @returns {boolean} 오류 상태 여부
   */
  const isErrorStatus = (status) => {
    return ['REJECTED'].includes(status);
  };

  return {
    statusTextMap,
    getStatusText,
    getStatusBadgeClass,
    getStatusPriority,
    isCompletedStatus,
    isPendingStatus,
    isErrorStatus,
  };
} 